<template>
  <div class="gauge_item">
    <router-link :to="link_to">
      <!--
      <p class='settings'>canvas: {{width}}w x {{height}} <br/>Category Class: {{category_class}}</p>
      -->
      <div class="gauge-title">
        <span ref="gauge-value" v-if="top" :class="gaugeValueClass"></span>
        <span v-if="top" :class="gaugeValueClass">{{ unit }}</span>
      </div>
      <div ref="gauge_category" class="gauge_category" :class="category_class" v-html="category" />
      <div ref="gauge_title" class="gauge_title">{{ title }}</div>
      <canvas class="gauge_canvas" ref="gauge" :height="height" :width="width"></canvas>
      <!--    <div ref="gauge_title" class="gauge_title">{{ title }}</div>
    <div class="gauge_subtitle">{{ subtitle }}</div>
      -->
      <div v-if="help_topic_id && help_topic_id.length" class="info" @click="showInfo">Info..</div>

      <div class="gauge_value">
        <span ref="gauge-value" v-if="!top" :class="gaugeValueClass" class="gauge_value_item"></span>
        <span v-if="!top" :class="gaugeValueClass" class="gauge_value_unit">{{ unit }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
/*  This is a modified version of v-gauge ( https://github.com/amroessam/vgauge )    */
import { Gauge, Donut } from "../../public/js/gauge";
export default {
  name: "GaugeItem",
  props: {
    link_to: {
      type: String,
      required: false
    },
    help_topic_id: {
      type: String,
      required: false
    },
    category: {
      type: String,
      default: ""
    },
    category_class: {
      type: String,
      default: "polling"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    unit: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: "200px"
    },
    width: {
      type: String,
      default: "300px"
    },
    decimalPlace: {
      type: Number,
      default: 0
    },
    gaugeValueClass: {
      type: String,
      default: ""
    },
    top: {
      type: Boolean,
      default: false
    },
    maxValue: {
      type: Number,
      default: 100
    },
    minValue: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function() {
        return {};
      }
    },
    animationSpeed: {
      type: Number,
      default: 10
    },
    initialValue: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    donut: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gauge: null,
      final_options: null
    };
  },
  mounted() {
    this.updateOptions();
    this.initializeGauge();
  },
  watch: {
    value: function(newVal) {
      this.gauge.set(newVal);
    },
    width: function(newVal) {
      this.width = newVal;
      this.initializeGauge();
    },
    height: function(newVal) {
      this.height = newVal;
      this.initializeGauge();
    },
    options: function(newOpts) {
      console.dir(newOpts);
      this.updateOptions();
      this.initializeGauge();
    }
  },
  methods: {
    showInfo() {
      // alert(`Show info for ${this.help_topic_id}`);
    },
    updateOptions() {
      let default_options = {
        angle: 0,
        lineWidth: 0.44,
        radiusScale: 0.75,
        pointer: {
          length: 0.6,
          strokeWidth: 0.035,
          color: "black"
        },
        staticZones: [
          {
            strokeStyle: "#ac1c00" /*reddish */,
            min: -50,
            max: 0
          },
          {
            strokeStyle: "#1c4587" /*bluish*/,
            min: 0,
            max: 50
          }
        ],
        staticLabels: {
          font: "12pt 'Roboto', sans-serif,'Archivo Black'", // Specifies font
          labels: [-50, 0, 50], // Print labels at these values
          color: "#000000", // Optional: Label text color
          fractionDigits: 0 // Optional: Numerical precision. 0=round off.
        },

        limitMax: false,
        limitMin: false,
        colorStart: "#6FADCF",
        colorStop: "#8FC0DA",
        strokeColor: "#E0E0E0",
        generateGradient: false,
        highDpiSupport: true
      };
      let new_options = JSON.parse(JSON.stringify(default_options));
      this.final_options = Object.assign(new_options, this.options);
      console.log(`Update the Options!:`);
      console.dir(this.final_options);
    },
    initializeGauge() {
      this.gauge = this.donut
        ? new Donut(this.$refs.gauge)
        : new Gauge(this.$refs.gauge);
      this.gauge.maxValue = this.maxValue;
      this.gauge.setMinValue(this.minValue);
      this.gauge.animationSpeed = this.animationSpeed;
      this.gauge.setOptions(this.final_options);
      this.gauge.setTextField(this.$refs["gauge-value"], this.decimalPlace);
      this.gauge.set(this.value);
    }
  }
};
</script>

<style >
.gauge_item {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0px;
  display: grid;
  font-family: "Roboto", sans-serif;
  max-width: 300px;
  min-height: 200px;
  font-size: 1rem;
  justify-content: center;
  align-content: center;
  border: 6px solid gainsboro;
  color: black;
  background-color: white;
}
.gauge_title,
.gauge_subtitle {
  display: block;
  align-self: center;
  font-weight: 900;
  margin: 0;
}
.gauge_title,
.gauge_value {
  z-index: 30;
}
.gauge_value {
  font-weight: bold;
  bottom: 1.75rem;
  padding: 2px;
}

.gauge_subtitle {
  bottom: 0.25rem;
  margin: auto;
}
.info {
  position: absolute;
  left: 0;
  bottom: 0;
  color: cornflowerblue;
}
.info:hover {
  color: navy;
  cursor: help;
}
.gauge_value span {
  padding: 0;
  margin: 0;
  margin-left: -1px;
}
.gauge_value_item {
  margin-left: 10px;
}
.gauge_title {
  position: absolute;
  top: 36px;
  left: 0;
  right: 0;
  /*  border: 3px dotted red;*/
}
.gauge_category {
  position: absolute;
  display: block;
  margin-right: 30px;
  margin-left: 20px;
  top: 10px;
  background-color: steelblue;
  color: white;
  font-size: 0.75rem;
  border-radius: 0.2rem;
  opacity: 0.7;
  padding: 3px;
}
.gauge_canvas {
  width: 95%;
  margin-top: 30px;
  align-self: center;
  justify-self: center;
  /* border: 3px dashed lime; */
}
.settings {
  position: absolute;
  opacity: 0.5;
}
.betting_markets {
  background-color: seagreen;
}
.models {
  background-color: #ff9900;
  /* 538 color: background-color:#f9b173; */
}
a,
a:visited {
  text-decoration: none;
}
</style>
